/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Home_SubInputs */

const en_wc_home_sub = /** @type {(inputs: Wc_Home_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraft is a free, open-source word processor from ArtCraft. Write in the editor below without an account, or download the desktop app for Windows, macOS or Linux. Find setup guides, beginner tutorials and a comparison with Microsoft Word.`)
};

/**
* | output |
* | --- |
* | "WordCraft is a free, open-source word processor from ArtCraft. Write in the editor below without an account, or download the desktop app for Windows, macOS o..." |
*
* @param {Wc_Home_SubInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_home_sub = /** @type {((inputs?: Wc_Home_SubInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Home_SubInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_home_sub(inputs)
});
export { wc_home_sub as "wc.home.sub" }